import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../../../base/services/data/api.service';
import { SuburbViewModel } from '../../../models/lookup-tables/suburbs/suburb-view.model';
import { SimpleLookupModel } from '../../../base/models/lookups/simple-lookup.model';

@Injectable()
export class SuburbsService {
    public error: any;
    public hasError: boolean;
    constructor(public apiService: ApiService) {
    }
    public getView(): Observable<SuburbViewModel[]> {
        return this.apiService.get<SuburbViewModel[]>(`api/Suburbs/GetView`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    public getSimple(): Observable<SimpleLookupModel[]> {
        return this.apiService.get<SimpleLookupModel[]>(`api/Suburbs/GetSimple`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    public getSuburbsForActiveRoutes(): Observable<SuburbViewModel[]> {
        return this.apiService.get<SuburbViewModel[]>(`api/Suburbs/GetSuburbsForActiveRoutes`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    public getChangeOverLocations(): Observable<SimpleLookupModel[]> {
        return this.apiService.get<SimpleLookupModel[]>(`api/Suburbs/GetChangeOverLocations`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    private handleError(error: HttpErrorResponse) {
        this.hasError = true;
        return throwError(() => error);
    }
}